import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  InviteTrustAccountGuestsPayload,
  TrustAccountGuestDTO,
  TrustAccountGuestEventDTO,
  TrustAccountGuestsDTO
} from '@sollapay/types';

const guestsPath = (trustAccountId: string) => `/trust_accounts/${trustAccountId}/guests`;

const guestPath = (trustAccountId: string, guestId: string) =>
  `${guestsPath(trustAccountId)}/${encodeURIComponent(guestId)}`;

export const trustAccountGuestsApi = {
  fetchGuests: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<TrustAccountGuestsDTO>> => {
    return client.get<ApiResponse<TrustAccountGuestsDTO>>(guestsPath(trustAccountId));
  },

  fetchGuestEvents: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<TrustAccountGuestEventDTO[]>> => {
    return client.get<ApiResponse<TrustAccountGuestEventDTO[]>>(
      `${guestsPath(trustAccountId)}/events`
    );
  },

  inviteGuests: async (
    client: HttpClient,
    trustAccountId: string,
    payload: InviteTrustAccountGuestsPayload
  ): Promise<ApiResponse<TrustAccountGuestsDTO>> => {
    return client.post<ApiResponse<TrustAccountGuestsDTO>, InviteTrustAccountGuestsPayload>(
      guestsPath(trustAccountId),
      payload
    );
  },

  removeGuest: async (
    client: HttpClient,
    trustAccountId: string,
    guestId: string
  ): Promise<void> => {
    return client.delete<void>(guestPath(trustAccountId, guestId));
  },

  resendInvite: async (
    client: HttpClient,
    trustAccountId: string,
    guestId: string
  ): Promise<ApiResponse<TrustAccountGuestDTO>> => {
    return client.post<ApiResponse<TrustAccountGuestDTO>>(
      `${guestPath(trustAccountId, guestId)}/resend`
    );
  }
};
